export const CLOUDINARY_CLOUD_NAME = "dyzndmawd";

export function isOurCloudinaryUrl(url) {
    if (!url || typeof url !== "string") return false;
    return url.includes(`res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/`);
}
